export enum ContractType {
    termConcession,
    precariousConcession,
    publicDock
}

export const ContractTpeName = new Map<number, string>([
    [ContractType.termConcession, 'TermConcession'],
    [ContractType.precariousConcession, 'PrecariousConcession'],
    [ContractType.publicDock, 'PublicDock']
]);


export const NameToContractType = new Map<string, ContractType>([
    ['TermConcession', ContractType.termConcession],
    ['PrecariousConcession', ContractType.precariousConcession],
    ['PublicDock', ContractType.publicDock],
]);